import { queryStringify, STORAGE_EVENT } from '@utils'
import { createMutationHelper, createRequestHelper, createStorageProvider } from '@utils/swr'
import { type CampaignProductsRequest } from '../types/apiRequest'
import { type CampaignProductsResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const provider = createStorageProvider('campaign-products', STORAGE_EVENT.sessionStorage)

const {
  useRequest,
} = createRequestHelper<FortuneApis['get']['campaignProducts'], CampaignProductsResponse, CampaignProductsRequest>({
  client: 'fortune',
  key: (params) => {
    if (!params) return null
    const { campaign_code, project_code, product_ids, country_code, merchant_id } = params
    if (!project_code || !campaign_code || !country_code) return null
    return `/campaigns/${campaign_code}/products?${queryStringify({
      project_code,
      country_code,
      product_ids,
      merchant_id,
    })}`
  },
  provider,
})

export const useApiCampaignProducts = useRequest

const {
  useMutation,
} = createMutationHelper<FortuneApis['get']['campaignProducts'], CampaignProductsResponse, CampaignProductsRequest>({
  client: 'fortune',
  key: '/products',
  fetcher: (_, { client, arg }) => {
    const { campaign_code, project_code, product_ids, country_code, merchant_id } = arg
    if (!project_code || !campaign_code || !country_code) {
      return Promise.reject(new Error('campaign_code and project_code are required'))
    }
    return client.get(`/campaigns/${campaign_code}/products?${queryStringify({
      project_code,
      country_code,
      product_ids,
      merchant_id,
    })}`)
  },
})

export const useApiMutationCampaignProducts = useMutation
